import { useState } from "react";
import Sidebar from "./Sidebar";

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background-50">
      {/* Desktop sidebar */}
      <div className="hidden lg:block">
        <Sidebar />
      </div>

      {/* Mobile sidebar overlay */}
      {mobileOpen && (
        <div className="lg:hidden fixed inset-0 z-40">
          <div className="absolute inset-0 bg-black/50" onClick={() => setMobileOpen(false)}></div>
          <div className="relative z-50">
            <Sidebar />
          </div>
        </div>
      )}

      {/* Main content */}
      <div className="lg:ml-60">
        {/* Mobile header */}
        <header className="lg:hidden h-14 bg-white border-b border-background-200 flex items-center justify-between px-4 sticky top-0 z-20">
          <button
            onClick={() => setMobileOpen(true)}
            className="w-9 h-9 rounded-md flex items-center justify-center text-foreground-600 hover:bg-background-100 transition-colors cursor-pointer"
          >
            <i className="ri-menu-3-line text-lg"></i>
          </button>
          <div className="flex items-center gap-2">
            <img src="/logo-mark.svg" alt="SupplyGuard" className="w-7 h-7 rounded-md" />
            <span className="text-foreground-800 text-sm font-semibold">SupplyGuard</span>
          </div>
          <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 text-[11px] font-semibold">
            TM
          </div>
        </header>

        {/* Page content */}
        <main className="p-4 md:p-6 lg:p-8">{children}</main>
      </div>
    </div>
  );
}